module.exports = __webpack_public_path__ + "img/hcwn.a06b383d.png";